/**
 * Map-Bilder und -Namen an einer Stelle.
 *
 * Das Veto-Rad braucht pro Map zwei Bilder: ein Foto, das das Kuchenstueck
 * ausfuellt, und ein Logo, das mittig darauf liegt. Beide sind optional --
 * fehlt das Foto, bleibt die gestreifte Flaeche stehen, fehlt das Logo,
 * zeichnet das Rad stattdessen den Namen als Pille.
 *
 * Die Dateinamen sind Konvention statt Liste: eine neue Map in `match.json`
 * braucht dann nur die Bilddateien, keinen Code.
 */

/** `de_mirage` -> `Mirage` */
export const mapLabel = (map) => map.replace(/^de_/, '').replace(/^./, (c) => c.toUpperCase());

/** `de_mirage` -> `mirage` */
const slug = (map) => map.replace(/^de_/, '').toLowerCase();

const base = process.env.PUBLIC_URL || '';

/** Foto fuer die Flaeche des Kuchenstuecks: `/maps/mirage.jpg` */
export const mapImage = (map) => `${base}/maps/${slug(map)}.jpg`;

/** Logo mittig auf dem Kuchenstueck, mit Transparenz: `/maps/mirage-logo.png` */
export const mapLogo = (map) => `${base}/maps/${slug(map)}-logo.png`;
